import {Link} from 'react-router-dom';
import {routes} from '../../../../routing/routes';
import GoogleButton from '../../common/components/GoogleButton';
import PasswordField from '../../common/components/PasswordField';
import SecondaryLink from '../../common/components/SecondaryLink';
import SubmitButton from '../../common/components/SubmitButton';
import useRegister from './useRegister';
import useLoginWithGoogleToken from '../../common/hooks/useLoginWithGoogleToken';
import {useI18n} from '../../../../common/providers/I18nProvider';
import Form from '../../common/components/Form';
import FormControl from '../../common/components/FormControl';
import EmailField from '../../common/components/EmailField';

export default function Register() {
	const {loading, formik, canNotSubmit, isEmailInvalid, isPasswordInvalid, checkboxHandler, agree} = useRegister();
	const {googleLoginButtonHandler, isLoading} = useLoginWithGoogleToken();
	const {i18n} = useI18n();

	return (
		<Form status={formik.status} handleSubmit={formik.handleSubmit} title='AUTH.REGISTER.TITLE'>
			<FormControl label='AUTH.REGISTER.FIELD.EMAIL.LABEL' isInvalid={isEmailInvalid} error={formik.errors.email}>
				<EmailField
					fieldProps={formik.getFieldProps('email')}
					isInvalid={isEmailInvalid}
					placeholder='AUTH.REGISTER.FIELD.EMAIL.PLACEHOLDER'
				/>
			</FormControl>

			<FormControl
				label='AUTH.REGISTER.FIELD.PASSWORD.LABEL'
				isInvalid={isPasswordInvalid}
				error={formik.errors.password}
			>
				<PasswordField fieldProps={formik.getFieldProps('password')} error={isPasswordInvalid} />
			</FormControl>

			<div className='mb-5 sm:mb-3 lg:mb-7 flex items-center'>
				<input type='checkbox' id='agree' onChange={checkboxHandler} className='mr-[6px]' />
				<label htmlFor='agree' className='text-sm sm:text-2xs lg:text-base'>
					<span className='text-black-50'>{i18n('AGREE.TO')}</span>{' '}
					<span className='text-rich-black font-medium'>
						<Link to='/term/condition' target='_blank' rel='noreferrer'>
							{i18n('TERM')}
						</Link>
					</span>{' '}
					<span className='text-black-50'>{i18n('AND')} </span>
					<span className='text-rich-black font-medium'>
						<Link to='/privacy/policy' target='_blank' rel='noreferrer'>
							{i18n('PRIVACY')}
						</Link>
					</span>
				</label>
			</div>

			<div className='mb-8 sm:mb-5 lg:mb-9 text-xs sm:text-3xs lg:text-sm text-black-50'>
				{i18n('CHECKBOX.MSSG')}
				<br />
			</div>

			<SubmitButton canNotSubmit={canNotSubmit} loading={loading}>
				{i18n('AUTH.REGISTER.BUTTON.NEXT')}
			</SubmitButton>

			<GoogleButton
				agree={agree}
				text={i18n('AUTH.REGISTER.BUTTON.GOOGLE')}
				buttonHandler={googleLoginButtonHandler}
				loading={isLoading}
			/>

			<SecondaryLink to={routes.login}>{i18n('AUTH.REGISTER.BUTTON.LOGIN')}</SecondaryLink>
		</Form>
	);
}
